import {HTTP} from "../../helpers/axios";
import { Action } from 'redux'
import {RootState} from '../../reducers'
import { ThunkAction } from 'redux-thunk'
import { serverRoutes} from "../../api/serverRoutes";
import {responseData} from "../../dataInterface/deviceDetailInterface";


export const searchDevicesWithoutDetails = (device:string,callback:(error:boolean)=>void):ThunkAction<void, RootState, unknown, Action<string>> => async (dispatch,getState) => {


    try {
        const response:responseData =  await   HTTP(getState,dispatch).post(serverRoutes.searchDeviceWithoutDetails,{
            unique_id:device
        });



        dispatch({
            type: 'SEARCH_DEVICES_NO_DETAILS',
            payload: response.data
        });

        let error=false;
        callback(error);

    }catch (e) {
        let error=true;
        callback(error);
    }

};

